// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/struct.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  ambit,
  ambitFromJSON,
  ambitToJSON,
  objectType,
  objectTypeFromJSON,
  objectTypeToJSON,
  techActiveWeaponry,
  techActiveWeaponryFromJSON,
  techActiveWeaponryToJSON,
  techOreReserveDefenses,
  techOreReserveDefensesFromJSON,
  techOreReserveDefensesToJSON,
  techPassiveWeaponry,
  techPassiveWeaponryFromJSON,
  techPassiveWeaponryToJSON,
  techPlanetaryDefenses,
  techPlanetaryDefensesFromJSON,
  techPlanetaryDefensesToJSON,
  techPlanetaryMining,
  techPlanetaryMiningFromJSON,
  techPlanetaryMiningToJSON,
  techPlanetaryRefineries,
  techPlanetaryRefineriesFromJSON,
  techPlanetaryRefineriesToJSON,
  techPowerGeneration,
  techPowerGenerationFromJSON,
  techPowerGenerationToJSON,
  techUnitDefenses,
  techUnitDefensesFromJSON,
  techUnitDefensesToJSON,
  techWeaponControl,
  techWeaponControlFromJSON,
  techWeaponControlToJSON,
} from "./keys";

export const protobufPackage = "structs.structs";

export interface Struct {
  id: string;
  index: string;
  type: string;
  creator: string;
  owner: string;
  locationType: objectType;
  locationId: string;
  operatingAmbit: ambit;
  slot: string;
}

export interface StructType {
  id: string;
  type: string;
  class: string;
  classAbbreviation: string;
  defaultCosmeticModelNumber: string;
  defaultCosmeticName: string;
  category: objectType;
  buildLimit: string;
  buildDifficulty: string;
  buildDraw: string;
  maxHealth: string;
  passiveDraw: string;
  possibleAmbit: string;
  movable: boolean;
  slotBound: boolean;
  primaryWeapon: techActiveWeaponry;
  primaryWeaponControl: techWeaponControl;
  primaryWeaponCharge: string;
  primaryWeaponAmbits: string;
  primaryWeaponTargets: string;
  primaryWeaponShots: string;
  primaryWeaponDamage: string;
  primaryWeaponBlockable: boolean;
  primaryWeaponCounterable: boolean;
  primaryWeaponRecoilDamage: string;
  primaryWeaponShotSuccessRateNumerator: string;
  primaryWeaponShotSuccessRateDenominator: string;
  secondaryWeapon: techActiveWeaponry;
  secondaryWeaponControl: techWeaponControl;
  secondaryWeaponCharge: string;
  secondaryWeaponAmbits: string;
  secondaryWeaponTargets: string;
  secondaryWeaponShots: string;
  secondaryWeaponDamage: string;
  secondaryWeaponBlockable: boolean;
  secondaryWeaponCounterable: boolean;
  secondaryWeaponRecoilDamage: string;
  secondaryWeaponShotSuccessRateNumerator: string;
  secondaryWeaponShotSuccessRateDenominator: string;
  passiveWeaponry: techPassiveWeaponry;
  unitDefenses: techUnitDefenses;
  oreReserveDefenses: techOreReserveDefenses;
  planetaryDefenses: techPlanetaryDefenses;
  planetaryMining: techPlanetaryMining;
  planetaryRefinery: techPlanetaryRefineries;
  powerGeneration: techPowerGeneration;
  activateCharge: string;
  buildCharge: string;
  defendChangeCharge: string;
  moveCharge: string;
  stealthActivateCharge: string;
  attackReduction: string;
  attackCounterable: boolean;
  stealthSystems: boolean;
  counterAttack: string;
  counterAttackSameAmbit: string;
  postDestructionDamage: string;
  generatingRate: string;
  planetaryShieldContribution: string;
  oreMiningDifficulty: string;
  oreRefiningDifficulty: string;
  unguidedDefensiveSuccessRateNumerator: string;
  unguidedDefensiveSuccessRateDenominator: string;
  guidedDefensiveSuccessRateNumerator: string;
  guidedDefensiveSuccessRateDenominator: string;
  triggerRaidDefeatByDestruction: boolean;
  primaryWeaponGuaranteedShots: string;
  secondaryWeaponGuaranteedShots: string;
  primaryWeaponArmourPiercing: boolean;
  secondaryWeaponArmourPiercing: boolean;
  canDefend: boolean;
}

export interface StructDefender {
  protectedStructId: string;
  defendingStructId: string;
}

export interface StructDefenders {
  structDefenders: StructDefender[];
}

export interface StructAttributeRecord {
  attributeId: string;
  value: string;
}

export interface StructAttributes {
  health: string;
  status: string;
  blockStartBuild: string;
  blockStartOreMine: string;
  blockStartOreRefine: string;
  protectedStructIndex: string;
  typeCount: string;
  isMaterialized: boolean;
  isBuilt: boolean;
  isOnline: boolean;
  isHidden: boolean;
  isDestroyed: boolean;
  isLocked: boolean;
}

export interface StructDestructionQueueRecord {
  sweepHeight: string;
  structId: string;
}

function createBaseStruct(): Struct {
  return {
    id: "",
    index: "0",
    type: "0",
    creator: "",
    owner: "",
    locationType: 0,
    locationId: "",
    operatingAmbit: 0,
    slot: "0",
  };
}

export const Struct: MessageFns<Struct> = {
  encode(message: Struct, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.index !== "0") {
      writer.uint32(16).uint64(message.index);
    }
    if (message.type !== "0") {
      writer.uint32(24).uint64(message.type);
    }
    if (message.creator !== "") {
      writer.uint32(34).string(message.creator);
    }
    if (message.owner !== "") {
      writer.uint32(42).string(message.owner);
    }
    if (message.locationType !== 0) {
      writer.uint32(48).int32(message.locationType);
    }
    if (message.locationId !== "") {
      writer.uint32(58).string(message.locationId);
    }
    if (message.operatingAmbit !== 0) {
      writer.uint32(64).int32(message.operatingAmbit);
    }
    if (message.slot !== "0") {
      writer.uint32(72).uint64(message.slot);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Struct {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStruct();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.index = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.owner = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.locationType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.locationId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.operatingAmbit = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.slot = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Struct {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "0",
      type: isSet(object.type) ? globalThis.String(object.type) : "0",
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      owner: isSet(object.owner) ? globalThis.String(object.owner) : "",
      locationType: isSet(object.locationType) ? objectTypeFromJSON(object.locationType) : 0,
      locationId: isSet(object.locationId) ? globalThis.String(object.locationId) : "",
      operatingAmbit: isSet(object.operatingAmbit) ? ambitFromJSON(object.operatingAmbit) : 0,
      slot: isSet(object.slot) ? globalThis.String(object.slot) : "0",
    };
  },

  toJSON(message: Struct): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.index !== "0") {
      obj.index = message.index;
    }
    if (message.type !== "0") {
      obj.type = message.type;
    }
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.owner !== "") {
      obj.owner = message.owner;
    }
    if (message.locationType !== 0) {
      obj.locationType = objectTypeToJSON(message.locationType);
    }
    if (message.locationId !== "") {
      obj.locationId = message.locationId;
    }
    if (message.operatingAmbit !== 0) {
      obj.operatingAmbit = ambitToJSON(message.operatingAmbit);
    }
    if (message.slot !== "0") {
      obj.slot = message.slot;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Struct>, I>>(base?: I): Struct {
    return Struct.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Struct>, I>>(object: I): Struct {
    const message = createBaseStruct();
    message.id = object.id ?? "";
    message.index = object.index ?? "0";
    message.type = object.type ?? "0";
    message.creator = object.creator ?? "";
    message.owner = object.owner ?? "";
    message.locationType = object.locationType ?? 0;
    message.locationId = object.locationId ?? "";
    message.operatingAmbit = object.operatingAmbit ?? 0;
    message.slot = object.slot ?? "0";
    return message;
  },
};

function createBaseStructType(): StructType {
  return {
    id: "0",
    type: "",
    class: "",
    classAbbreviation: "",
    defaultCosmeticModelNumber: "",
    defaultCosmeticName: "",
    category: 0,
    buildLimit: "0",
    buildDifficulty: "0",
    buildDraw: "0",
    maxHealth: "0",
    passiveDraw: "0",
    possibleAmbit: "0",
    movable: false,
    slotBound: false,
    primaryWeapon: 0,
    primaryWeaponControl: 0,
    primaryWeaponCharge: "0",
    primaryWeaponAmbits: "0",
    primaryWeaponTargets: "0",
    primaryWeaponShots: "0",
    primaryWeaponDamage: "0",
    primaryWeaponBlockable: false,
    primaryWeaponCounterable: false,
    primaryWeaponRecoilDamage: "0",
    primaryWeaponShotSuccessRateNumerator: "0",
    primaryWeaponShotSuccessRateDenominator: "0",
    secondaryWeapon: 0,
    secondaryWeaponControl: 0,
    secondaryWeaponCharge: "0",
    secondaryWeaponAmbits: "0",
    secondaryWeaponTargets: "0",
    secondaryWeaponShots: "0",
    secondaryWeaponDamage: "0",
    secondaryWeaponBlockable: false,
    secondaryWeaponCounterable: false,
    secondaryWeaponRecoilDamage: "0",
    secondaryWeaponShotSuccessRateNumerator: "0",
    secondaryWeaponShotSuccessRateDenominator: "0",
    passiveWeaponry: 0,
    unitDefenses: 0,
    oreReserveDefenses: 0,
    planetaryDefenses: 0,
    planetaryMining: 0,
    planetaryRefinery: 0,
    powerGeneration: 0,
    activateCharge: "0",
    buildCharge: "0",
    defendChangeCharge: "0",
    moveCharge: "0",
    stealthActivateCharge: "0",
    attackReduction: "0",
    attackCounterable: false,
    stealthSystems: false,
    counterAttack: "0",
    counterAttackSameAmbit: "0",
    postDestructionDamage: "0",
    generatingRate: "0",
    planetaryShieldContribution: "0",
    oreMiningDifficulty: "0",
    oreRefiningDifficulty: "0",
    unguidedDefensiveSuccessRateNumerator: "0",
    unguidedDefensiveSuccessRateDenominator: "0",
    guidedDefensiveSuccessRateNumerator: "0",
    guidedDefensiveSuccessRateDenominator: "0",
    triggerRaidDefeatByDestruction: false,
    primaryWeaponGuaranteedShots: "0",
    secondaryWeaponGuaranteedShots: "0",
    primaryWeaponArmourPiercing: false,
    secondaryWeaponArmourPiercing: false,
    canDefend: false,
  };
}

export const StructType: MessageFns<StructType> = {
  encode(message: StructType, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "0") {
      writer.uint32(8).uint64(message.id);
    }
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    if (message.class !== "") {
      writer.uint32(506).string(message.class);
    }
    if (message.classAbbreviation !== "") {
      writer.uint32(514).string(message.classAbbreviation);
    }
    if (message.defaultCosmeticModelNumber !== "") {
      writer.uint32(522).string(message.defaultCosmeticModelNumber);
    }
    if (message.defaultCosmeticName !== "") {
      writer.uint32(530).string(message.defaultCosmeticName);
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.buildLimit !== "0") {
      writer.uint32(32).uint64(message.buildLimit);
    }
    if (message.buildDifficulty !== "0") {
      writer.uint32(40).uint64(message.buildDifficulty);
    }
    if (message.buildDraw !== "0") {
      writer.uint32(48).uint64(message.buildDraw);
    }
    if (message.maxHealth !== "0") {
      writer.uint32(56).uint64(message.maxHealth);
    }
    if (message.passiveDraw !== "0") {
      writer.uint32(64).uint64(message.passiveDraw);
    }
    if (message.possibleAmbit !== "0") {
      writer.uint32(72).uint64(message.possibleAmbit);
    }
    if (message.movable !== false) {
      writer.uint32(80).bool(message.movable);
    }
    if (message.slotBound !== false) {
      writer.uint32(88).bool(message.slotBound);
    }
    if (message.primaryWeapon !== 0) {
      writer.uint32(96).int32(message.primaryWeapon);
    }
    if (message.primaryWeaponControl !== 0) {
      writer.uint32(104).int32(message.primaryWeaponControl);
    }
    if (message.primaryWeaponCharge !== "0") {
      writer.uint32(112).uint64(message.primaryWeaponCharge);
    }
    if (message.primaryWeaponAmbits !== "0") {
      writer.uint32(120).uint64(message.primaryWeaponAmbits);
    }
    if (message.primaryWeaponTargets !== "0") {
      writer.uint32(128).uint64(message.primaryWeaponTargets);
    }
    if (message.primaryWeaponShots !== "0") {
      writer.uint32(136).uint64(message.primaryWeaponShots);
    }
    if (message.primaryWeaponDamage !== "0") {
      writer.uint32(144).uint64(message.primaryWeaponDamage);
    }
    if (message.primaryWeaponBlockable !== false) {
      writer.uint32(152).bool(message.primaryWeaponBlockable);
    }
    if (message.primaryWeaponCounterable !== false) {
      writer.uint32(160).bool(message.primaryWeaponCounterable);
    }
    if (message.primaryWeaponRecoilDamage !== "0") {
      writer.uint32(168).uint64(message.primaryWeaponRecoilDamage);
    }
    if (message.primaryWeaponShotSuccessRateNumerator !== "0") {
      writer.uint32(176).uint64(message.primaryWeaponShotSuccessRateNumerator);
    }
    if (message.primaryWeaponShotSuccessRateDenominator !== "0") {
      writer.uint32(184).uint64(message.primaryWeaponShotSuccessRateDenominator);
    }
    if (message.secondaryWeapon !== 0) {
      writer.uint32(192).int32(message.secondaryWeapon);
    }
    if (message.secondaryWeaponControl !== 0) {
      writer.uint32(200).int32(message.secondaryWeaponControl);
    }
    if (message.secondaryWeaponCharge !== "0") {
      writer.uint32(208).uint64(message.secondaryWeaponCharge);
    }
    if (message.secondaryWeaponAmbits !== "0") {
      writer.uint32(216).uint64(message.secondaryWeaponAmbits);
    }
    if (message.secondaryWeaponTargets !== "0") {
      writer.uint32(224).uint64(message.secondaryWeaponTargets);
    }
    if (message.secondaryWeaponShots !== "0") {
      writer.uint32(232).uint64(message.secondaryWeaponShots);
    }
    if (message.secondaryWeaponDamage !== "0") {
      writer.uint32(240).uint64(message.secondaryWeaponDamage);
    }
    if (message.secondaryWeaponBlockable !== false) {
      writer.uint32(248).bool(message.secondaryWeaponBlockable);
    }
    if (message.secondaryWeaponCounterable !== false) {
      writer.uint32(256).bool(message.secondaryWeaponCounterable);
    }
    if (message.secondaryWeaponRecoilDamage !== "0") {
      writer.uint32(264).uint64(message.secondaryWeaponRecoilDamage);
    }
    if (message.secondaryWeaponShotSuccessRateNumerator !== "0") {
      writer.uint32(272).uint64(message.secondaryWeaponShotSuccessRateNumerator);
    }
    if (message.secondaryWeaponShotSuccessRateDenominator !== "0") {
      writer.uint32(280).uint64(message.secondaryWeaponShotSuccessRateDenominator);
    }
    if (message.passiveWeaponry !== 0) {
      writer.uint32(288).int32(message.passiveWeaponry);
    }
    if (message.unitDefenses !== 0) {
      writer.uint32(296).int32(message.unitDefenses);
    }
    if (message.oreReserveDefenses !== 0) {
      writer.uint32(304).int32(message.oreReserveDefenses);
    }
    if (message.planetaryDefenses !== 0) {
      writer.uint32(312).int32(message.planetaryDefenses);
    }
    if (message.planetaryMining !== 0) {
      writer.uint32(320).int32(message.planetaryMining);
    }
    if (message.planetaryRefinery !== 0) {
      writer.uint32(328).int32(message.planetaryRefinery);
    }
    if (message.powerGeneration !== 0) {
      writer.uint32(336).int32(message.powerGeneration);
    }
    if (message.activateCharge !== "0") {
      writer.uint32(344).uint64(message.activateCharge);
    }
    if (message.buildCharge !== "0") {
      writer.uint32(352).uint64(message.buildCharge);
    }
    if (message.defendChangeCharge !== "0") {
      writer.uint32(360).uint64(message.defendChangeCharge);
    }
    if (message.moveCharge !== "0") {
      writer.uint32(368).uint64(message.moveCharge);
    }
    if (message.stealthActivateCharge !== "0") {
      writer.uint32(376).uint64(message.stealthActivateCharge);
    }
    if (message.attackReduction !== "0") {
      writer.uint32(384).uint64(message.attackReduction);
    }
    if (message.attackCounterable !== false) {
      writer.uint32(392).bool(message.attackCounterable);
    }
    if (message.stealthSystems !== false) {
      writer.uint32(400).bool(message.stealthSystems);
    }
    if (message.counterAttack !== "0") {
      writer.uint32(408).uint64(message.counterAttack);
    }
    if (message.counterAttackSameAmbit !== "0") {
      writer.uint32(416).uint64(message.counterAttackSameAmbit);
    }
    if (message.postDestructionDamage !== "0") {
      writer.uint32(424).uint64(message.postDestructionDamage);
    }
    if (message.generatingRate !== "0") {
      writer.uint32(432).uint64(message.generatingRate);
    }
    if (message.planetaryShieldContribution !== "0") {
      writer.uint32(440).uint64(message.planetaryShieldContribution);
    }
    if (message.oreMiningDifficulty !== "0") {
      writer.uint32(448).uint64(message.oreMiningDifficulty);
    }
    if (message.oreRefiningDifficulty !== "0") {
      writer.uint32(456).uint64(message.oreRefiningDifficulty);
    }
    if (message.unguidedDefensiveSuccessRateNumerator !== "0") {
      writer.uint32(464).uint64(message.unguidedDefensiveSuccessRateNumerator);
    }
    if (message.unguidedDefensiveSuccessRateDenominator !== "0") {
      writer.uint32(472).uint64(message.unguidedDefensiveSuccessRateDenominator);
    }
    if (message.guidedDefensiveSuccessRateNumerator !== "0") {
      writer.uint32(480).uint64(message.guidedDefensiveSuccessRateNumerator);
    }
    if (message.guidedDefensiveSuccessRateDenominator !== "0") {
      writer.uint32(488).uint64(message.guidedDefensiveSuccessRateDenominator);
    }
    if (message.triggerRaidDefeatByDestruction !== false) {
      writer.uint32(496).bool(message.triggerRaidDefeatByDestruction);
    }
    if (message.primaryWeaponGuaranteedShots !== "0") {
      writer.uint32(536).uint64(message.primaryWeaponGuaranteedShots);
    }
    if (message.secondaryWeaponGuaranteedShots !== "0") {
      writer.uint32(544).uint64(message.secondaryWeaponGuaranteedShots);
    }
    if (message.primaryWeaponArmourPiercing !== false) {
      writer.uint32(552).bool(message.primaryWeaponArmourPiercing);
    }
    if (message.secondaryWeaponArmourPiercing !== false) {
      writer.uint32(560).bool(message.secondaryWeaponArmourPiercing);
    }
    if (message.canDefend !== false) {
      writer.uint32(568).bool(message.canDefend);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StructType {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 63: {
          if (tag !== 506) {
            break;
          }

          message.class = reader.string();
          continue;
        }
        case 64: {
          if (tag !== 514) {
            break;
          }

          message.classAbbreviation = reader.string();
          continue;
        }
        case 65: {
          if (tag !== 522) {
            break;
          }

          message.defaultCosmeticModelNumber = reader.string();
          continue;
        }
        case 66: {
          if (tag !== 530) {
            break;
          }

          message.defaultCosmeticName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.buildLimit = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.buildDifficulty = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.buildDraw = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.maxHealth = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.passiveDraw = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.possibleAmbit = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.movable = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.slotBound = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.primaryWeapon = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.primaryWeaponControl = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.primaryWeaponCharge = reader.uint64().toString();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.primaryWeaponAmbits = reader.uint64().toString();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.primaryWeaponTargets = reader.uint64().toString();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.primaryWeaponShots = reader.uint64().toString();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.primaryWeaponDamage = reader.uint64().toString();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.primaryWeaponBlockable = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.primaryWeaponCounterable = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.primaryWeaponRecoilDamage = reader.uint64().toString();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.primaryWeaponShotSuccessRateNumerator = reader.uint64().toString();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.primaryWeaponShotSuccessRateDenominator = reader.uint64().toString();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.secondaryWeapon = reader.int32() as any;
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.secondaryWeaponControl = reader.int32() as any;
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.secondaryWeaponCharge = reader.uint64().toString();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.secondaryWeaponAmbits = reader.uint64().toString();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.secondaryWeaponTargets = reader.uint64().toString();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.secondaryWeaponShots = reader.uint64().toString();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.secondaryWeaponDamage = reader.uint64().toString();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.secondaryWeaponBlockable = reader.bool();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.secondaryWeaponCounterable = reader.bool();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.secondaryWeaponRecoilDamage = reader.uint64().toString();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.secondaryWeaponShotSuccessRateNumerator = reader.uint64().toString();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.secondaryWeaponShotSuccessRateDenominator = reader.uint64().toString();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.passiveWeaponry = reader.int32() as any;
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.unitDefenses = reader.int32() as any;
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.oreReserveDefenses = reader.int32() as any;
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.planetaryDefenses = reader.int32() as any;
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.planetaryMining = reader.int32() as any;
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.planetaryRefinery = reader.int32() as any;
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.powerGeneration = reader.int32() as any;
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.activateCharge = reader.uint64().toString();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.buildCharge = reader.uint64().toString();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.defendChangeCharge = reader.uint64().toString();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.moveCharge = reader.uint64().toString();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.stealthActivateCharge = reader.uint64().toString();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.attackReduction = reader.uint64().toString();
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.attackCounterable = reader.bool();
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.stealthSystems = reader.bool();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.counterAttack = reader.uint64().toString();
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.counterAttackSameAmbit = reader.uint64().toString();
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.postDestructionDamage = reader.uint64().toString();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.generatingRate = reader.uint64().toString();
          continue;
        }
        case 55: {
          if (tag !== 440) {
            break;
          }

          message.planetaryShieldContribution = reader.uint64().toString();
          continue;
        }
        case 56: {
          if (tag !== 448) {
            break;
          }

          message.oreMiningDifficulty = reader.uint64().toString();
          continue;
        }
        case 57: {
          if (tag !== 456) {
            break;
          }

          message.oreRefiningDifficulty = reader.uint64().toString();
          continue;
        }
        case 58: {
          if (tag !== 464) {
            break;
          }

          message.unguidedDefensiveSuccessRateNumerator = reader.uint64().toString();
          continue;
        }
        case 59: {
          if (tag !== 472) {
            break;
          }

          message.unguidedDefensiveSuccessRateDenominator = reader.uint64().toString();
          continue;
        }
        case 60: {
          if (tag !== 480) {
            break;
          }

          message.guidedDefensiveSuccessRateNumerator = reader.uint64().toString();
          continue;
        }
        case 61: {
          if (tag !== 488) {
            break;
          }

          message.guidedDefensiveSuccessRateDenominator = reader.uint64().toString();
          continue;
        }
        case 62: {
          if (tag !== 496) {
            break;
          }

          message.triggerRaidDefeatByDestruction = reader.bool();
          continue;
        }
        case 67: {
          if (tag !== 536) {
            break;
          }

          message.primaryWeaponGuaranteedShots = reader.uint64().toString();
          continue;
        }
        case 68: {
          if (tag !== 544) {
            break;
          }

          message.secondaryWeaponGuaranteedShots = reader.uint64().toString();
          continue;
        }
        case 69: {
          if (tag !== 552) {
            break;
          }

          message.primaryWeaponArmourPiercing = reader.bool();
          continue;
        }
        case 70: {
          if (tag !== 560) {
            break;
          }

          message.secondaryWeaponArmourPiercing = reader.bool();
          continue;
        }
        case 71: {
          if (tag !== 568) {
            break;
          }

          message.canDefend = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StructType {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "0",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      class: isSet(object.class) ? globalThis.String(object.class) : "",
      classAbbreviation: isSet(object.classAbbreviation) ? globalThis.String(object.classAbbreviation) : "",
      defaultCosmeticModelNumber: isSet(object.defaultCosmeticModelNumber)
        ? globalThis.String(object.defaultCosmeticModelNumber)
        : "",
      defaultCosmeticName: isSet(object.defaultCosmeticName) ? globalThis.String(object.defaultCosmeticName) : "",
      category: isSet(object.category) ? objectTypeFromJSON(object.category) : 0,
      buildLimit: isSet(object.buildLimit) ? globalThis.String(object.buildLimit) : "0",
      buildDifficulty: isSet(object.buildDifficulty) ? globalThis.String(object.buildDifficulty) : "0",
      buildDraw: isSet(object.buildDraw) ? globalThis.String(object.buildDraw) : "0",
      maxHealth: isSet(object.maxHealth) ? globalThis.String(object.maxHealth) : "0",
      passiveDraw: isSet(object.passiveDraw) ? globalThis.String(object.passiveDraw) : "0",
      possibleAmbit: isSet(object.possibleAmbit) ? globalThis.String(object.possibleAmbit) : "0",
      movable: isSet(object.movable) ? globalThis.Boolean(object.movable) : false,
      slotBound: isSet(object.slotBound) ? globalThis.Boolean(object.slotBound) : false,
      primaryWeapon: isSet(object.primaryWeapon) ? techActiveWeaponryFromJSON(object.primaryWeapon) : 0,
      primaryWeaponControl: isSet(object.primaryWeaponControl)
        ? techWeaponControlFromJSON(object.primaryWeaponControl)
        : 0,
      primaryWeaponCharge: isSet(object.primaryWeaponCharge) ? globalThis.String(object.primaryWeaponCharge) : "0",
      primaryWeaponAmbits: isSet(object.primaryWeaponAmbits) ? globalThis.String(object.primaryWeaponAmbits) : "0",
      primaryWeaponTargets: isSet(object.primaryWeaponTargets) ? globalThis.String(object.primaryWeaponTargets) : "0",
      primaryWeaponShots: isSet(object.primaryWeaponShots) ? globalThis.String(object.primaryWeaponShots) : "0",
      primaryWeaponDamage: isSet(object.primaryWeaponDamage) ? globalThis.String(object.primaryWeaponDamage) : "0",
      primaryWeaponBlockable: isSet(object.primaryWeaponBlockable)
        ? globalThis.Boolean(object.primaryWeaponBlockable)
        : false,
      primaryWeaponCounterable: isSet(object.primaryWeaponCounterable)
        ? globalThis.Boolean(object.primaryWeaponCounterable)
        : false,
      primaryWeaponRecoilDamage: isSet(object.primaryWeaponRecoilDamage)
        ? globalThis.String(object.primaryWeaponRecoilDamage)
        : "0",
      primaryWeaponShotSuccessRateNumerator: isSet(object.primaryWeaponShotSuccessRateNumerator)
        ? globalThis.String(object.primaryWeaponShotSuccessRateNumerator)
        : "0",
      primaryWeaponShotSuccessRateDenominator: isSet(object.primaryWeaponShotSuccessRateDenominator)
        ? globalThis.String(object.primaryWeaponShotSuccessRateDenominator)
        : "0",
      secondaryWeapon: isSet(object.secondaryWeapon) ? techActiveWeaponryFromJSON(object.secondaryWeapon) : 0,
      secondaryWeaponControl: isSet(object.secondaryWeaponControl)
        ? techWeaponControlFromJSON(object.secondaryWeaponControl)
        : 0,
      secondaryWeaponCharge: isSet(object.secondaryWeaponCharge)
        ? globalThis.String(object.secondaryWeaponCharge)
        : "0",
      secondaryWeaponAmbits: isSet(object.secondaryWeaponAmbits)
        ? globalThis.String(object.secondaryWeaponAmbits)
        : "0",
      secondaryWeaponTargets: isSet(object.secondaryWeaponTargets)
        ? globalThis.String(object.secondaryWeaponTargets)
        : "0",
      secondaryWeaponShots: isSet(object.secondaryWeaponShots) ? globalThis.String(object.secondaryWeaponShots) : "0",
      secondaryWeaponDamage: isSet(object.secondaryWeaponDamage)
        ? globalThis.String(object.secondaryWeaponDamage)
        : "0",
      secondaryWeaponBlockable: isSet(object.secondaryWeaponBlockable)
        ? globalThis.Boolean(object.secondaryWeaponBlockable)
        : false,
      secondaryWeaponCounterable: isSet(object.secondaryWeaponCounterable)
        ? globalThis.Boolean(object.secondaryWeaponCounterable)
        : false,
      secondaryWeaponRecoilDamage: isSet(object.secondaryWeaponRecoilDamage)
        ? globalThis.String(object.secondaryWeaponRecoilDamage)
        : "0",
      secondaryWeaponShotSuccessRateNumerator: isSet(object.secondaryWeaponShotSuccessRateNumerator)
        ? globalThis.String(object.secondaryWeaponShotSuccessRateNumerator)
        : "0",
      secondaryWeaponShotSuccessRateDenominator: isSet(object.secondaryWeaponShotSuccessRateDenominator)
        ? globalThis.String(object.secondaryWeaponShotSuccessRateDenominator)
        : "0",
      passiveWeaponry: isSet(object.passiveWeaponry) ? techPassiveWeaponryFromJSON(object.passiveWeaponry) : 0,
      unitDefenses: isSet(object.unitDefenses) ? techUnitDefensesFromJSON(object.unitDefenses) : 0,
      oreReserveDefenses: isSet(object.oreReserveDefenses)
        ? techOreReserveDefensesFromJSON(object.oreReserveDefenses)
        : 0,
      planetaryDefenses: isSet(object.planetaryDefenses) ? techPlanetaryDefensesFromJSON(object.planetaryDefenses) : 0,
      planetaryMining: isSet(object.planetaryMining) ? techPlanetaryMiningFromJSON(object.planetaryMining) : 0,
      planetaryRefinery: isSet(object.planetaryRefinery)
        ? techPlanetaryRefineriesFromJSON(object.planetaryRefinery)
        : 0,
      powerGeneration: isSet(object.powerGeneration) ? techPowerGenerationFromJSON(object.powerGeneration) : 0,
      activateCharge: isSet(object.activateCharge) ? globalThis.String(object.activateCharge) : "0",
      buildCharge: isSet(object.buildCharge) ? globalThis.String(object.buildCharge) : "0",
      defendChangeCharge: isSet(object.defendChangeCharge) ? globalThis.String(object.defendChangeCharge) : "0",
      moveCharge: isSet(object.moveCharge) ? globalThis.String(object.moveCharge) : "0",
      stealthActivateCharge: isSet(object.stealthActivateCharge)
        ? globalThis.String(object.stealthActivateCharge)
        : "0",
      attackReduction: isSet(object.attackReduction) ? globalThis.String(object.attackReduction) : "0",
      attackCounterable: isSet(object.attackCounterable) ? globalThis.Boolean(object.attackCounterable) : false,
      stealthSystems: isSet(object.stealthSystems) ? globalThis.Boolean(object.stealthSystems) : false,
      counterAttack: isSet(object.counterAttack) ? globalThis.String(object.counterAttack) : "0",
      counterAttackSameAmbit: isSet(object.counterAttackSameAmbit)
        ? globalThis.String(object.counterAttackSameAmbit)
        : "0",
      postDestructionDamage: isSet(object.postDestructionDamage)
        ? globalThis.String(object.postDestructionDamage)
        : "0",
      generatingRate: isSet(object.generatingRate) ? globalThis.String(object.generatingRate) : "0",
      planetaryShieldContribution: isSet(object.planetaryShieldContribution)
        ? globalThis.String(object.planetaryShieldContribution)
        : "0",
      oreMiningDifficulty: isSet(object.oreMiningDifficulty) ? globalThis.String(object.oreMiningDifficulty) : "0",
      oreRefiningDifficulty: isSet(object.oreRefiningDifficulty)
        ? globalThis.String(object.oreRefiningDifficulty)
        : "0",
      unguidedDefensiveSuccessRateNumerator: isSet(object.unguidedDefensiveSuccessRateNumerator)
        ? globalThis.String(object.unguidedDefensiveSuccessRateNumerator)
        : "0",
      unguidedDefensiveSuccessRateDenominator: isSet(object.unguidedDefensiveSuccessRateDenominator)
        ? globalThis.String(object.unguidedDefensiveSuccessRateDenominator)
        : "0",
      guidedDefensiveSuccessRateNumerator: isSet(object.guidedDefensiveSuccessRateNumerator)
        ? globalThis.String(object.guidedDefensiveSuccessRateNumerator)
        : "0",
      guidedDefensiveSuccessRateDenominator: isSet(object.guidedDefensiveSuccessRateDenominator)
        ? globalThis.String(object.guidedDefensiveSuccessRateDenominator)
        : "0",
      triggerRaidDefeatByDestruction: isSet(object.triggerRaidDefeatByDestruction)
        ? globalThis.Boolean(object.triggerRaidDefeatByDestruction)
        : false,
      primaryWeaponGuaranteedShots: isSet(object.primaryWeaponGuaranteedShots)
        ? globalThis.String(object.primaryWeaponGuaranteedShots)
        : "0",
      secondaryWeaponGuaranteedShots: isSet(object.secondaryWeaponGuaranteedShots)
        ? globalThis.String(object.secondaryWeaponGuaranteedShots)
        : "0",
      primaryWeaponArmourPiercing: isSet(object.primaryWeaponArmourPiercing)
        ? globalThis.Boolean(object.primaryWeaponArmourPiercing)
        : false,
      secondaryWeaponArmourPiercing: isSet(object.secondaryWeaponArmourPiercing)
        ? globalThis.Boolean(object.secondaryWeaponArmourPiercing)
        : false,
      canDefend: isSet(object.canDefend) ? globalThis.Boolean(object.canDefend) : false,
    };
  },

  toJSON(message: StructType): unknown {
    const obj: any = {};
    if (message.id !== "0") {
      obj.id = message.id;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.class !== "") {
      obj.class = message.class;
    }
    if (message.classAbbreviation !== "") {
      obj.classAbbreviation = message.classAbbreviation;
    }
    if (message.defaultCosmeticModelNumber !== "") {
      obj.defaultCosmeticModelNumber = message.defaultCosmeticModelNumber;
    }
    if (message.defaultCosmeticName !== "") {
      obj.defaultCosmeticName = message.defaultCosmeticName;
    }
    if (message.category !== 0) {
      obj.category = objectTypeToJSON(message.category);
    }
    if (message.buildLimit !== "0") {
      obj.buildLimit = message.buildLimit;
    }
    if (message.buildDifficulty !== "0") {
      obj.buildDifficulty = message.buildDifficulty;
    }
    if (message.buildDraw !== "0") {
      obj.buildDraw = message.buildDraw;
    }
    if (message.maxHealth !== "0") {
      obj.maxHealth = message.maxHealth;
    }
    if (message.passiveDraw !== "0") {
      obj.passiveDraw = message.passiveDraw;
    }
    if (message.possibleAmbit !== "0") {
      obj.possibleAmbit = message.possibleAmbit;
    }
    if (message.movable !== false) {
      obj.movable = message.movable;
    }
    if (message.slotBound !== false) {
      obj.slotBound = message.slotBound;
    }
    if (message.primaryWeapon !== 0) {
      obj.primaryWeapon = techActiveWeaponryToJSON(message.primaryWeapon);
    }
    if (message.primaryWeaponControl !== 0) {
      obj.primaryWeaponControl = techWeaponControlToJSON(message.primaryWeaponControl);
    }
    if (message.primaryWeaponCharge !== "0") {
      obj.primaryWeaponCharge = message.primaryWeaponCharge;
    }
    if (message.primaryWeaponAmbits !== "0") {
      obj.primaryWeaponAmbits = message.primaryWeaponAmbits;
    }
    if (message.primaryWeaponTargets !== "0") {
      obj.primaryWeaponTargets = message.primaryWeaponTargets;
    }
    if (message.primaryWeaponShots !== "0") {
      obj.primaryWeaponShots = message.primaryWeaponShots;
    }
    if (message.primaryWeaponDamage !== "0") {
      obj.primaryWeaponDamage = message.primaryWeaponDamage;
    }
    if (message.primaryWeaponBlockable !== false) {
      obj.primaryWeaponBlockable = message.primaryWeaponBlockable;
    }
    if (message.primaryWeaponCounterable !== false) {
      obj.primaryWeaponCounterable = message.primaryWeaponCounterable;
    }
    if (message.primaryWeaponRecoilDamage !== "0") {
      obj.primaryWeaponRecoilDamage = message.primaryWeaponRecoilDamage;
    }
    if (message.primaryWeaponShotSuccessRateNumerator !== "0") {
      obj.primaryWeaponShotSuccessRateNumerator = message.primaryWeaponShotSuccessRateNumerator;
    }
    if (message.primaryWeaponShotSuccessRateDenominator !== "0") {
      obj.primaryWeaponShotSuccessRateDenominator = message.primaryWeaponShotSuccessRateDenominator;
    }
    if (message.secondaryWeapon !== 0) {
      obj.secondaryWeapon = techActiveWeaponryToJSON(message.secondaryWeapon);
    }
    if (message.secondaryWeaponControl !== 0) {
      obj.secondaryWeaponControl = techWeaponControlToJSON(message.secondaryWeaponControl);
    }
    if (message.secondaryWeaponCharge !== "0") {
      obj.secondaryWeaponCharge = message.secondaryWeaponCharge;
    }
    if (message.secondaryWeaponAmbits !== "0") {
      obj.secondaryWeaponAmbits = message.secondaryWeaponAmbits;
    }
    if (message.secondaryWeaponTargets !== "0") {
      obj.secondaryWeaponTargets = message.secondaryWeaponTargets;
    }
    if (message.secondaryWeaponShots !== "0") {
      obj.secondaryWeaponShots = message.secondaryWeaponShots;
    }
    if (message.secondaryWeaponDamage !== "0") {
      obj.secondaryWeaponDamage = message.secondaryWeaponDamage;
    }
    if (message.secondaryWeaponBlockable !== false) {
      obj.secondaryWeaponBlockable = message.secondaryWeaponBlockable;
    }
    if (message.secondaryWeaponCounterable !== false) {
      obj.secondaryWeaponCounterable = message.secondaryWeaponCounterable;
    }
    if (message.secondaryWeaponRecoilDamage !== "0") {
      obj.secondaryWeaponRecoilDamage = message.secondaryWeaponRecoilDamage;
    }
    if (message.secondaryWeaponShotSuccessRateNumerator !== "0") {
      obj.secondaryWeaponShotSuccessRateNumerator = message.secondaryWeaponShotSuccessRateNumerator;
    }
    if (message.secondaryWeaponShotSuccessRateDenominator !== "0") {
      obj.secondaryWeaponShotSuccessRateDenominator = message.secondaryWeaponShotSuccessRateDenominator;
    }
    if (message.passiveWeaponry !== 0) {
      obj.passiveWeaponry = techPassiveWeaponryToJSON(message.passiveWeaponry);
    }
    if (message.unitDefenses !== 0) {
      obj.unitDefenses = techUnitDefensesToJSON(message.unitDefenses);
    }
    if (message.oreReserveDefenses !== 0) {
      obj.oreReserveDefenses = techOreReserveDefensesToJSON(message.oreReserveDefenses);
    }
    if (message.planetaryDefenses !== 0) {
      obj.planetaryDefenses = techPlanetaryDefensesToJSON(message.planetaryDefenses);
    }
    if (message.planetaryMining !== 0) {
      obj.planetaryMining = techPlanetaryMiningToJSON(message.planetaryMining);
    }
    if (message.planetaryRefinery !== 0) {
      obj.planetaryRefinery = techPlanetaryRefineriesToJSON(message.planetaryRefinery);
    }
    if (message.powerGeneration !== 0) {
      obj.powerGeneration = techPowerGenerationToJSON(message.powerGeneration);
    }
    if (message.activateCharge !== "0") {
      obj.activateCharge = message.activateCharge;
    }
    if (message.buildCharge !== "0") {
      obj.buildCharge = message.buildCharge;
    }
    if (message.defendChangeCharge !== "0") {
      obj.defendChangeCharge = message.defendChangeCharge;
    }
    if (message.moveCharge !== "0") {
      obj.moveCharge = message.moveCharge;
    }
    if (message.stealthActivateCharge !== "0") {
      obj.stealthActivateCharge = message.stealthActivateCharge;
    }
    if (message.attackReduction !== "0") {
      obj.attackReduction = message.attackReduction;
    }
    if (message.attackCounterable !== false) {
      obj.attackCounterable = message.attackCounterable;
    }
    if (message.stealthSystems !== false) {
      obj.stealthSystems = message.stealthSystems;
    }
    if (message.counterAttack !== "0") {
      obj.counterAttack = message.counterAttack;
    }
    if (message.counterAttackSameAmbit !== "0") {
      obj.counterAttackSameAmbit = message.counterAttackSameAmbit;
    }
    if (message.postDestructionDamage !== "0") {
      obj.postDestructionDamage = message.postDestructionDamage;
    }
    if (message.generatingRate !== "0") {
      obj.generatingRate = message.generatingRate;
    }
    if (message.planetaryShieldContribution !== "0") {
      obj.planetaryShieldContribution = message.planetaryShieldContribution;
    }
    if (message.oreMiningDifficulty !== "0") {
      obj.oreMiningDifficulty = message.oreMiningDifficulty;
    }
    if (message.oreRefiningDifficulty !== "0") {
      obj.oreRefiningDifficulty = message.oreRefiningDifficulty;
    }
    if (message.unguidedDefensiveSuccessRateNumerator !== "0") {
      obj.unguidedDefensiveSuccessRateNumerator = message.unguidedDefensiveSuccessRateNumerator;
    }
    if (message.unguidedDefensiveSuccessRateDenominator !== "0") {
      obj.unguidedDefensiveSuccessRateDenominator = message.unguidedDefensiveSuccessRateDenominator;
    }
    if (message.guidedDefensiveSuccessRateNumerator !== "0") {
      obj.guidedDefensiveSuccessRateNumerator = message.guidedDefensiveSuccessRateNumerator;
    }
    if (message.guidedDefensiveSuccessRateDenominator !== "0") {
      obj.guidedDefensiveSuccessRateDenominator = message.guidedDefensiveSuccessRateDenominator;
    }
    if (message.triggerRaidDefeatByDestruction !== false) {
      obj.triggerRaidDefeatByDestruction = message.triggerRaidDefeatByDestruction;
    }
    if (message.primaryWeaponGuaranteedShots !== "0") {
      obj.primaryWeaponGuaranteedShots = message.primaryWeaponGuaranteedShots;
    }
    if (message.secondaryWeaponGuaranteedShots !== "0") {
      obj.secondaryWeaponGuaranteedShots = message.secondaryWeaponGuaranteedShots;
    }
    if (message.primaryWeaponArmourPiercing !== false) {
      obj.primaryWeaponArmourPiercing = message.primaryWeaponArmourPiercing;
    }
    if (message.secondaryWeaponArmourPiercing !== false) {
      obj.secondaryWeaponArmourPiercing = message.secondaryWeaponArmourPiercing;
    }
    if (message.canDefend !== false) {
      obj.canDefend = message.canDefend;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StructType>, I>>(base?: I): StructType {
    return StructType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructType>, I>>(object: I): StructType {
    const message = createBaseStructType();
    message.id = object.id ?? "0";
    message.type = object.type ?? "";
    message.class = object.class ?? "";
    message.classAbbreviation = object.classAbbreviation ?? "";
    message.defaultCosmeticModelNumber = object.defaultCosmeticModelNumber ?? "";
    message.defaultCosmeticName = object.defaultCosmeticName ?? "";
    message.category = object.category ?? 0;
    message.buildLimit = object.buildLimit ?? "0";
    message.buildDifficulty = object.buildDifficulty ?? "0";
    message.buildDraw = object.buildDraw ?? "0";
    message.maxHealth = object.maxHealth ?? "0";
    message.passiveDraw = object.passiveDraw ?? "0";
    message.possibleAmbit = object.possibleAmbit ?? "0";
    message.movable = object.movable ?? false;
    message.slotBound = object.slotBound ?? false;
    message.primaryWeapon = object.primaryWeapon ?? 0;
    message.primaryWeaponControl = object.primaryWeaponControl ?? 0;
    message.primaryWeaponCharge = object.primaryWeaponCharge ?? "0";
    message.primaryWeaponAmbits = object.primaryWeaponAmbits ?? "0";
    message.primaryWeaponTargets = object.primaryWeaponTargets ?? "0";
    message.primaryWeaponShots = object.primaryWeaponShots ?? "0";
    message.primaryWeaponDamage = object.primaryWeaponDamage ?? "0";
    message.primaryWeaponBlockable = object.primaryWeaponBlockable ?? false;
    message.primaryWeaponCounterable = object.primaryWeaponCounterable ?? false;
    message.primaryWeaponRecoilDamage = object.primaryWeaponRecoilDamage ?? "0";
    message.primaryWeaponShotSuccessRateNumerator = object.primaryWeaponShotSuccessRateNumerator ?? "0";
    message.primaryWeaponShotSuccessRateDenominator = object.primaryWeaponShotSuccessRateDenominator ?? "0";
    message.secondaryWeapon = object.secondaryWeapon ?? 0;
    message.secondaryWeaponControl = object.secondaryWeaponControl ?? 0;
    message.secondaryWeaponCharge = object.secondaryWeaponCharge ?? "0";
    message.secondaryWeaponAmbits = object.secondaryWeaponAmbits ?? "0";
    message.secondaryWeaponTargets = object.secondaryWeaponTargets ?? "0";
    message.secondaryWeaponShots = object.secondaryWeaponShots ?? "0";
    message.secondaryWeaponDamage = object.secondaryWeaponDamage ?? "0";
    message.secondaryWeaponBlockable = object.secondaryWeaponBlockable ?? false;
    message.secondaryWeaponCounterable = object.secondaryWeaponCounterable ?? false;
    message.secondaryWeaponRecoilDamage = object.secondaryWeaponRecoilDamage ?? "0";
    message.secondaryWeaponShotSuccessRateNumerator = object.secondaryWeaponShotSuccessRateNumerator ?? "0";
    message.secondaryWeaponShotSuccessRateDenominator = object.secondaryWeaponShotSuccessRateDenominator ?? "0";
    message.passiveWeaponry = object.passiveWeaponry ?? 0;
    message.unitDefenses = object.unitDefenses ?? 0;
    message.oreReserveDefenses = object.oreReserveDefenses ?? 0;
    message.planetaryDefenses = object.planetaryDefenses ?? 0;
    message.planetaryMining = object.planetaryMining ?? 0;
    message.planetaryRefinery = object.planetaryRefinery ?? 0;
    message.powerGeneration = object.powerGeneration ?? 0;
    message.activateCharge = object.activateCharge ?? "0";
    message.buildCharge = object.buildCharge ?? "0";
    message.defendChangeCharge = object.defendChangeCharge ?? "0";
    message.moveCharge = object.moveCharge ?? "0";
    message.stealthActivateCharge = object.stealthActivateCharge ?? "0";
    message.attackReduction = object.attackReduction ?? "0";
    message.attackCounterable = object.attackCounterable ?? false;
    message.stealthSystems = object.stealthSystems ?? false;
    message.counterAttack = object.counterAttack ?? "0";
    message.counterAttackSameAmbit = object.counterAttackSameAmbit ?? "0";
    message.postDestructionDamage = object.postDestructionDamage ?? "0";
    message.generatingRate = object.generatingRate ?? "0";
    message.planetaryShieldContribution = object.planetaryShieldContribution ?? "0";
    message.oreMiningDifficulty = object.oreMiningDifficulty ?? "0";
    message.oreRefiningDifficulty = object.oreRefiningDifficulty ?? "0";
    message.unguidedDefensiveSuccessRateNumerator = object.unguidedDefensiveSuccessRateNumerator ?? "0";
    message.unguidedDefensiveSuccessRateDenominator = object.unguidedDefensiveSuccessRateDenominator ?? "0";
    message.guidedDefensiveSuccessRateNumerator = object.guidedDefensiveSuccessRateNumerator ?? "0";
    message.guidedDefensiveSuccessRateDenominator = object.guidedDefensiveSuccessRateDenominator ?? "0";
    message.triggerRaidDefeatByDestruction = object.triggerRaidDefeatByDestruction ?? false;
    message.primaryWeaponGuaranteedShots = object.primaryWeaponGuaranteedShots ?? "0";
    message.secondaryWeaponGuaranteedShots = object.secondaryWeaponGuaranteedShots ?? "0";
    message.primaryWeaponArmourPiercing = object.primaryWeaponArmourPiercing ?? false;
    message.secondaryWeaponArmourPiercing = object.secondaryWeaponArmourPiercing ?? false;
    message.canDefend = object.canDefend ?? false;
    return message;
  },
};

function createBaseStructDefender(): StructDefender {
  return { protectedStructId: "", defendingStructId: "" };
}

export const StructDefender: MessageFns<StructDefender> = {
  encode(message: StructDefender, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.protectedStructId !== "") {
      writer.uint32(10).string(message.protectedStructId);
    }
    if (message.defendingStructId !== "") {
      writer.uint32(18).string(message.defendingStructId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StructDefender {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructDefender();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.protectedStructId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.defendingStructId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StructDefender {
    return {
      protectedStructId: isSet(object.protectedStructId) ? globalThis.String(object.protectedStructId) : "",
      defendingStructId: isSet(object.defendingStructId) ? globalThis.String(object.defendingStructId) : "",
    };
  },

  toJSON(message: StructDefender): unknown {
    const obj: any = {};
    if (message.protectedStructId !== "") {
      obj.protectedStructId = message.protectedStructId;
    }
    if (message.defendingStructId !== "") {
      obj.defendingStructId = message.defendingStructId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StructDefender>, I>>(base?: I): StructDefender {
    return StructDefender.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructDefender>, I>>(object: I): StructDefender {
    const message = createBaseStructDefender();
    message.protectedStructId = object.protectedStructId ?? "";
    message.defendingStructId = object.defendingStructId ?? "";
    return message;
  },
};

function createBaseStructDefenders(): StructDefenders {
  return { structDefenders: [] };
}

export const StructDefenders: MessageFns<StructDefenders> = {
  encode(message: StructDefenders, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.structDefenders) {
      StructDefender.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StructDefenders {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructDefenders();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.structDefenders.push(StructDefender.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StructDefenders {
    return {
      structDefenders: globalThis.Array.isArray(object?.structDefenders)
        ? object.structDefenders.map((e: any) => StructDefender.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StructDefenders): unknown {
    const obj: any = {};
    if (message.structDefenders?.length) {
      obj.structDefenders = message.structDefenders.map((e) => StructDefender.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StructDefenders>, I>>(base?: I): StructDefenders {
    return StructDefenders.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructDefenders>, I>>(object: I): StructDefenders {
    const message = createBaseStructDefenders();
    message.structDefenders = object.structDefenders?.map((e) => StructDefender.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStructAttributeRecord(): StructAttributeRecord {
  return { attributeId: "", value: "0" };
}

export const StructAttributeRecord: MessageFns<StructAttributeRecord> = {
  encode(message: StructAttributeRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attributeId !== "") {
      writer.uint32(10).string(message.attributeId);
    }
    if (message.value !== "0") {
      writer.uint32(16).uint64(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StructAttributeRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructAttributeRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attributeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StructAttributeRecord {
    return {
      attributeId: isSet(object.attributeId) ? globalThis.String(object.attributeId) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "0",
    };
  },

  toJSON(message: StructAttributeRecord): unknown {
    const obj: any = {};
    if (message.attributeId !== "") {
      obj.attributeId = message.attributeId;
    }
    if (message.value !== "0") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StructAttributeRecord>, I>>(base?: I): StructAttributeRecord {
    return StructAttributeRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructAttributeRecord>, I>>(object: I): StructAttributeRecord {
    const message = createBaseStructAttributeRecord();
    message.attributeId = object.attributeId ?? "";
    message.value = object.value ?? "0";
    return message;
  },
};

function createBaseStructAttributes(): StructAttributes {
  return {
    health: "0",
    status: "0",
    blockStartBuild: "0",
    blockStartOreMine: "0",
    blockStartOreRefine: "0",
    protectedStructIndex: "0",
    typeCount: "0",
    isMaterialized: false,
    isBuilt: false,
    isOnline: false,
    isHidden: false,
    isDestroyed: false,
    isLocked: false,
  };
}

export const StructAttributes: MessageFns<StructAttributes> = {
  encode(message: StructAttributes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.health !== "0") {
      writer.uint32(8).uint64(message.health);
    }
    if (message.status !== "0") {
      writer.uint32(16).uint64(message.status);
    }
    if (message.blockStartBuild !== "0") {
      writer.uint32(24).uint64(message.blockStartBuild);
    }
    if (message.blockStartOreMine !== "0") {
      writer.uint32(32).uint64(message.blockStartOreMine);
    }
    if (message.blockStartOreRefine !== "0") {
      writer.uint32(40).uint64(message.blockStartOreRefine);
    }
    if (message.protectedStructIndex !== "0") {
      writer.uint32(48).uint64(message.protectedStructIndex);
    }
    if (message.typeCount !== "0") {
      writer.uint32(56).uint64(message.typeCount);
    }
    if (message.isMaterialized !== false) {
      writer.uint32(64).bool(message.isMaterialized);
    }
    if (message.isBuilt !== false) {
      writer.uint32(72).bool(message.isBuilt);
    }
    if (message.isOnline !== false) {
      writer.uint32(80).bool(message.isOnline);
    }
    if (message.isHidden !== false) {
      writer.uint32(88).bool(message.isHidden);
    }
    if (message.isDestroyed !== false) {
      writer.uint32(96).bool(message.isDestroyed);
    }
    if (message.isLocked !== false) {
      writer.uint32(104).bool(message.isLocked);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StructAttributes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructAttributes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.health = reader.uint64().toString();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.blockStartBuild = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.blockStartOreMine = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.blockStartOreRefine = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.protectedStructIndex = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.typeCount = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isMaterialized = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isBuilt = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.isOnline = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.isHidden = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isDestroyed = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isLocked = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StructAttributes {
    return {
      health: isSet(object.health) ? globalThis.String(object.health) : "0",
      status: isSet(object.status) ? globalThis.String(object.status) : "0",
      blockStartBuild: isSet(object.blockStartBuild) ? globalThis.String(object.blockStartBuild) : "0",
      blockStartOreMine: isSet(object.blockStartOreMine) ? globalThis.String(object.blockStartOreMine) : "0",
      blockStartOreRefine: isSet(object.blockStartOreRefine) ? globalThis.String(object.blockStartOreRefine) : "0",
      protectedStructIndex: isSet(object.protectedStructIndex) ? globalThis.String(object.protectedStructIndex) : "0",
      typeCount: isSet(object.typeCount) ? globalThis.String(object.typeCount) : "0",
      isMaterialized: isSet(object.isMaterialized) ? globalThis.Boolean(object.isMaterialized) : false,
      isBuilt: isSet(object.isBuilt) ? globalThis.Boolean(object.isBuilt) : false,
      isOnline: isSet(object.isOnline) ? globalThis.Boolean(object.isOnline) : false,
      isHidden: isSet(object.isHidden) ? globalThis.Boolean(object.isHidden) : false,
      isDestroyed: isSet(object.isDestroyed) ? globalThis.Boolean(object.isDestroyed) : false,
      isLocked: isSet(object.isLocked) ? globalThis.Boolean(object.isLocked) : false,
    };
  },

  toJSON(message: StructAttributes): unknown {
    const obj: any = {};
    if (message.health !== "0") {
      obj.health = message.health;
    }
    if (message.status !== "0") {
      obj.status = message.status;
    }
    if (message.blockStartBuild !== "0") {
      obj.blockStartBuild = message.blockStartBuild;
    }
    if (message.blockStartOreMine !== "0") {
      obj.blockStartOreMine = message.blockStartOreMine;
    }
    if (message.blockStartOreRefine !== "0") {
      obj.blockStartOreRefine = message.blockStartOreRefine;
    }
    if (message.protectedStructIndex !== "0") {
      obj.protectedStructIndex = message.protectedStructIndex;
    }
    if (message.typeCount !== "0") {
      obj.typeCount = message.typeCount;
    }
    if (message.isMaterialized !== false) {
      obj.isMaterialized = message.isMaterialized;
    }
    if (message.isBuilt !== false) {
      obj.isBuilt = message.isBuilt;
    }
    if (message.isOnline !== false) {
      obj.isOnline = message.isOnline;
    }
    if (message.isHidden !== false) {
      obj.isHidden = message.isHidden;
    }
    if (message.isDestroyed !== false) {
      obj.isDestroyed = message.isDestroyed;
    }
    if (message.isLocked !== false) {
      obj.isLocked = message.isLocked;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StructAttributes>, I>>(base?: I): StructAttributes {
    return StructAttributes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructAttributes>, I>>(object: I): StructAttributes {
    const message = createBaseStructAttributes();
    message.health = object.health ?? "0";
    message.status = object.status ?? "0";
    message.blockStartBuild = object.blockStartBuild ?? "0";
    message.blockStartOreMine = object.blockStartOreMine ?? "0";
    message.blockStartOreRefine = object.blockStartOreRefine ?? "0";
    message.protectedStructIndex = object.protectedStructIndex ?? "0";
    message.typeCount = object.typeCount ?? "0";
    message.isMaterialized = object.isMaterialized ?? false;
    message.isBuilt = object.isBuilt ?? false;
    message.isOnline = object.isOnline ?? false;
    message.isHidden = object.isHidden ?? false;
    message.isDestroyed = object.isDestroyed ?? false;
    message.isLocked = object.isLocked ?? false;
    return message;
  },
};

function createBaseStructDestructionQueueRecord(): StructDestructionQueueRecord {
  return { sweepHeight: "0", structId: "" };
}

export const StructDestructionQueueRecord: MessageFns<StructDestructionQueueRecord> = {
  encode(message: StructDestructionQueueRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sweepHeight !== "0") {
      writer.uint32(8).int64(message.sweepHeight);
    }
    if (message.structId !== "") {
      writer.uint32(18).string(message.structId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StructDestructionQueueRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructDestructionQueueRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sweepHeight = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.structId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StructDestructionQueueRecord {
    return {
      sweepHeight: isSet(object.sweepHeight) ? globalThis.String(object.sweepHeight) : "0",
      structId: isSet(object.structId) ? globalThis.String(object.structId) : "",
    };
  },

  toJSON(message: StructDestructionQueueRecord): unknown {
    const obj: any = {};
    if (message.sweepHeight !== "0") {
      obj.sweepHeight = message.sweepHeight;
    }
    if (message.structId !== "") {
      obj.structId = message.structId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StructDestructionQueueRecord>, I>>(base?: I): StructDestructionQueueRecord {
    return StructDestructionQueueRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructDestructionQueueRecord>, I>>(object: I): StructDestructionQueueRecord {
    const message = createBaseStructDestructionQueueRecord();
    message.sweepHeight = object.sweepHeight ?? "0";
    message.structId = object.structId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
